import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import AppUrl from '../../restApi/AppUrl';
import IRestClient from '../../restApi/IRestClient';
import { FaPhone, FaEnvelope, FaChevronDown, FaTwitter, FaFacebook, FaYoutube, FaInstagram, FaHandHoldingHeart } from 'react-icons/fa';
import { FiX, FiMenu } from 'react-icons/fi';

const navLinks = [
  { to: '/', label: 'Home' },
  { to: '/about', label: 'About' },
  { to: '/allevents', label: 'Events' },
  { to: '/allprojects', label: 'Projects' },
  { to: '/allteam', label: 'Team' },
  { to: '/contact', label: 'Contact' },
];

class Topnavbar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      number: "...",
      email: "...",
      facebook: "...",
      youtube: "...",
      twitter: "...",
      instagram: "...",
      logo_img: "",
      pageTitle: props.title,
      isSticky: false,
      isMobileMenuOpen: false,
      isScrolled: false,
      isDropdownOpen: false,
      isMobile: false
    };
    this.dropdownRef = React.createRef();
  }

  componentDidMount() {
    this.checkScreenSize();
    window.addEventListener('resize', this.checkScreenSize);

    IRestClient.GetRequest(AppUrl.Footer).then(result => {
      if (result && result[0]) {
        this.setState({
          email: result[0]['email'],
          number: result[0]['number'],
          facebook: result[0]['facebook'],
          youtube: result[0]['youtube'],
          twitter: result[0]['twitter'],
          instagram: result[0]['instagram'],
        });
      }
    });

    IRestClient.GetRequest(AppUrl.logo).then(result => {
      if (result && result[0]) {
        this.setState({ logo_img: result[0]['logo_img'] });
      }
    });

    window.addEventListener('scroll', this.handleScroll);
    document.addEventListener('click', this.handleClickOutside);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
    document.removeEventListener('click', this.handleClickOutside);
    window.removeEventListener('resize', this.checkScreenSize);
  }

  checkScreenSize = () => {
    this.setState({ isMobile: window.innerWidth < 768 });
  };

  handleScroll = () => {
    const scrollPosition = window.scrollY;
    this.setState({
      isSticky: scrollPosition > 50,
      isScrolled: scrollPosition > 10
    });
  };

  toggleMobileMenu = () => {
    this.setState(prevState => ({
      isMobileMenuOpen: !prevState.isMobileMenuOpen,
      isDropdownOpen: false
    }));
  };

  closeMobileMenu = () => {
    this.setState({ isMobileMenuOpen: false, isDropdownOpen: false });
  };

  toggleDropdown = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState(prevState => ({ isDropdownOpen: !prevState.isDropdownOpen }));
  };

  closeDropdown = () => {
    this.setState({ isDropdownOpen: false });
  };

  closeMobileMenuAndDropdown = () => {
    this.setState({ isMobileMenuOpen: false, isDropdownOpen: false });
  };

  handleClickOutside = (event) => {
    if (this.dropdownRef.current && !this.dropdownRef.current.contains(event.target)) {
      this.setState({ isDropdownOpen: false });
    }
  };

  isLinkActive = (to) => {
    const { pathname } = this.props.location;
    if (to === '/') return pathname === '/';
    if (to === '/allprojects') return pathname.startsWith('/allprojects') || pathname.startsWith('/projectdetails');
    if (to === '/allevents') return pathname.startsWith('/allevents') || pathname.startsWith('/eventdetails');
    return pathname.startsWith(to);
  };

  isGalleryActive = () => {
    const { pathname } = this.props.location;
    return pathname.startsWith('/allgallery') || pathname.startsWith('/allvideogallery');
  };

  render() {
    const {
      isSticky,
      logo_img,
      number,
      email,
      facebook,
      youtube,
      twitter,
      instagram,
      isMobileMenuOpen,
      isScrolled,
      isDropdownOpen,
      isMobile
    } = this.state;

    return (
      <>
        {/* Top Info Bar */}
        <div className="bg-primary-900 border-b border-primary-700 border-opacity-40 relative z-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex items-center justify-between py-2 flex-wrap gap-2">
              {/* Contact Info */}
              <div className="flex items-center gap-4 sm:gap-6 flex-wrap">
                <a
                  href={`tel:${number}`}
                  className="flex items-center gap-2 text-primary-200 hover:text-white text-xs sm:text-sm transition-colors duration-200"
                >
                  <FaPhone className="text-tertiary-500 text-xs" />
                  <span>{number}</span>
                </a>
                <a
                  href={`mailto:${email}`}
                  className="flex items-center gap-2 text-primary-200 hover:text-white text-xs sm:text-sm transition-colors duration-200"
                >
                  <FaEnvelope className="text-tertiary-500 text-xs" />
                  <span className="hidden sm:inline">{email}</span>
                </a>
              </div>

              {/* Social Icons */}
              <div className="flex items-center gap-2 sm:gap-3">
                {twitter && (
                  <a href={twitter} target="_blank" rel="noopener noreferrer"
                    className="w-7 h-7 sm:w-8 sm:h-8 rounded-full bg-primary-700 hover:bg-primary-600 flex items-center justify-center text-primary-200 hover:text-white transition-all duration-200">
                    <FaTwitter className="text-xs sm:text-sm" />
                  </a>
                )}
                {facebook && (
                  <a href={facebook} target="_blank" rel="noopener noreferrer"
                    className="w-7 h-7 sm:w-8 sm:h-8 rounded-full bg-primary-700 hover:bg-primary-600 flex items-center justify-center text-primary-200 hover:text-white transition-all duration-200">
                    <FaFacebook className="text-xs sm:text-sm" />
                  </a>
                )}
                {youtube && (
                  <a href={youtube} target="_blank" rel="noopener noreferrer"
                    className="w-7 h-7 sm:w-8 sm:h-8 rounded-full bg-primary-700 hover:bg-primary-600 flex items-center justify-center text-primary-200 hover:text-white transition-all duration-200">
                    <FaYoutube className="text-xs sm:text-sm" />
                  </a>
                )}
                {instagram && (
                  <a href={instagram} target="_blank" rel="noopener noreferrer"
                    className="w-7 h-7 sm:w-8 sm:h-8 rounded-full bg-primary-700 hover:bg-primary-600 flex items-center justify-center text-primary-200 hover:text-white transition-all duration-200">
                    <FaInstagram className="text-xs sm:text-sm" />
                  </a>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Main Navigation */}
        <nav className={`sticky top-0 left-0 right-0 z-40 transition-all duration-300 ${
          isScrolled
            ? 'backdrop-blur-md bg-white bg-opacity-97 shadow-lg border-b border-neutral-100'
            : 'bg-white shadow-sm border-b border-neutral-100'
        }`}>
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex items-center justify-between h-16 sm:h-18 lg:h-20">

              {/* Logo */}
              <Link to="/" onClick={this.closeMobileMenuAndDropdown} className="flex items-center flex-shrink-0">
                {logo_img && (
                  <img
                    src={logo_img}
                    alt="SOYAN Logo"
                    className={`object-contain w-auto transition-all duration-300 ${isSticky ? 'h-10' : 'h-12'}`}
                  />
                )}
              </Link>

              {/* Desktop Nav Links */}
              <div className="hidden md:flex items-center gap-1">
                {navLinks.map(link => (
                  <Link
                    key={link.to}
                    to={link.to}
                    onClick={this.closeMobileMenuAndDropdown}
                    className={`px-4 py-2 text-sm font-semibold rounded-lg transition-all duration-200 ${
                      this.isLinkActive(link.to)
                        ? 'text-secondary-600 bg-secondary-50'
                        : 'text-primary-800 hover:text-secondary-600 hover:bg-secondary-50'
                    }`}
                  >
                    {link.label}
                  </Link>
                ))}

                {/* Gallery Dropdown */}
                <div ref={this.dropdownRef} className="relative">
                  <button
                    onClick={this.toggleDropdown}
                    className={`flex items-center gap-1.5 px-4 py-2 text-sm font-semibold rounded-lg transition-all duration-200 ${
                      isDropdownOpen || this.isGalleryActive()
                        ? 'text-secondary-600 bg-secondary-50'
                        : 'text-primary-800 hover:text-secondary-600 hover:bg-secondary-50'
                    }`}
                  >
                    Gallery
                    <FaChevronDown className={`text-xs transition-transform duration-300 ${isDropdownOpen ? 'rotate-180' : ''}`} />
                  </button>

                  {isDropdownOpen && (
                    <div className="absolute top-full left-1/2 -translate-x-1/2 mt-2 w-52 bg-white rounded-2xl shadow-xl border border-neutral-100 py-2 z-50">
                      <Link
                        to="/allgallery"
                        onClick={this.closeMobileMenuAndDropdown}
                        className="flex items-center gap-3 px-5 py-3 text-sm font-medium text-primary-800 hover:text-secondary-600 hover:bg-secondary-50 transition-colors duration-200"
                      >
                        <span>Photo Gallery</span>
                      </Link>
                      <Link
                        to="/allvideogallery"
                        onClick={this.closeMobileMenuAndDropdown}
                        className="flex items-center gap-3 px-5 py-3 text-sm font-medium text-primary-800 hover:text-secondary-600 hover:bg-secondary-50 transition-colors duration-200"
                      >
                        <span>Video Gallery</span>
                      </Link>
                    </div>
                  )}
                </div>
              </div>

              {/* Desktop Donate Button — hidden until payment goes live */}
              {false && (
                <div className="hidden md:flex items-center">
                  <Link
                    to="/donate"
                    onClick={this.closeMobileMenuAndDropdown}
                    className="inline-flex items-center gap-2 bg-secondary-600 hover:bg-secondary-700 text-white font-bold text-sm px-5 py-2.5 rounded-full transition-all duration-300 shadow-md hover:shadow-lg"
                  >
                    <FaHandHoldingHeart />
                    Donate
                  </Link>
                </div>
              )}

              {/* Mobile Hamburger */}
              <button
                onClick={this.toggleMobileMenu}
                className="md:hidden flex items-center justify-center w-10 h-10 rounded-xl bg-neutral-100 hover:bg-neutral-200 text-primary-800 transition-all duration-200"
                aria-label="Toggle menu"
              >
                {isMobileMenuOpen ? <FiX className="text-xl" /> : <FiMenu className="text-xl" />}
              </button>
            </div>
          </div>

          {/* Mobile Menu */}
          {isMobileMenuOpen && (
            <div className="md:hidden border-t border-neutral-100 bg-white shadow-lg">
              <div className="px-4 py-3 flex flex-col gap-1">
                {navLinks.map(link => (
                  <Link
                    key={link.to}
                    to={link.to}
                    onClick={this.closeMobileMenuAndDropdown}
                    className={`px-4 py-3 text-sm font-semibold rounded-xl transition-all duration-200 ${
                      this.isLinkActive(link.to)
                        ? 'text-secondary-600 bg-secondary-50 border-l-4 border-secondary-600'
                        : 'text-primary-800 hover:text-secondary-600 hover:bg-secondary-50'
                    }`}
                  >
                    {link.label}
                  </Link>
                ))}

                {/* Gallery toggle in mobile */}
                <div>
                  <button
                    onClick={this.toggleDropdown}
                    className={`w-full flex items-center justify-between px-4 py-3 text-sm font-semibold rounded-xl transition-all duration-200 ${
                      isDropdownOpen || this.isGalleryActive()
                        ? 'text-secondary-600 bg-secondary-50 border-l-4 border-secondary-600'
                        : 'text-primary-800 hover:bg-secondary-50'
                    }`}
                  >
                    <span>Gallery</span>
                    <FaChevronDown className={`text-xs transition-transform duration-300 ${isDropdownOpen ? 'rotate-180' : ''}`} />
                  </button>
                  {isDropdownOpen && (
                    <div className="ml-4 mt-1 flex flex-col gap-0.5">
                      <Link
                        to="/allgallery"
                        onClick={this.closeMobileMenuAndDropdown}
                        className="px-4 py-2.5 text-sm font-medium text-primary-700 hover:text-secondary-600 hover:bg-secondary-50 rounded-xl transition-all duration-200 border-l-2 border-secondary-400"
                      >
                        Photo Gallery
                      </Link>
                      <Link
                        to="/allvideogallery"
                        onClick={this.closeMobileMenuAndDropdown}
                        className="px-4 py-2.5 text-sm font-medium text-primary-700 hover:text-secondary-600 hover:bg-secondary-50 rounded-xl transition-all duration-200 border-l-2 border-secondary-400"
                      >
                        Video Gallery
                      </Link>
                    </div>
                  )}
                </div>

                {/* Mobile Donate — hidden until payment goes live */}
                {false && (
                  <div className="pt-2 pb-1">
                    <Link
                      to="/donate"
                      onClick={this.closeMobileMenuAndDropdown}
                      className="flex items-center justify-center gap-2 bg-secondary-600 hover:bg-secondary-700 text-white font-bold text-sm px-5 py-3 rounded-xl transition-all duration-300 shadow-md"
                    >
                      <FaHandHoldingHeart />
                      Donate Now
                    </Link>
                  </div>
                )}
              </div>
            </div>
          )}
        </nav>
      </>
    );
  }
}

export default withRouter(Topnavbar);
